/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_CopiedInputs */

const en_common_copied = /** @type {(inputs: Common_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

const id_common_copied = /** @type {(inputs: Common_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tersalin`)
};

/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Common_CopiedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const common_copied = /** @type {((inputs?: Common_CopiedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_CopiedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_common_copied(inputs)
	return en_common_copied(inputs)
});